import { useContext } from 'react';

import { ComposerContext } from 'src/pages/landlord/leads/messages/context/composer-context';

export const useComposer = () => {
    const context = useContext(ComposerContext);

    if (!context) {
        throw new Error('useComposer must be used within a ComposerProvider');
    }

    return context;
};
